<div class="flex flex-col gap-8 idp-date-picker-mach-core">
  <button
    [id]="triggerElementId"
    [idpErrorState]="!!fieldErrorInfo?.errMessage"
    class="min-h-[64px] h-[inherit] bg-surface-02 rounded-02 focus-visible:outline-stroke-03 flex w-100 cursor-pointer items-center justify-between px-16 focus-visible:border-transparent focus-visible:outline focus-visible:outline-2 date-picker-trigger-btn grayscale-effect"
    (click)="toggleDatePickerOpenState()"
    [ngClass]="{
      '!border-[2px] border-stroke-alert':
        fieldErrorInfo && fieldErrorInfo.status,
      '!border-[1px] border-stroke-01':
        !fieldErrorInfo || !fieldErrorInfo.status
    }"
    [attr.aria-label]="ariaLabelSelectedDate"
  >
    <div class="flex flex-col items-start">
      <div class="flex items-center gap-8">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          class="text-icon-primary"
        >
          <path
            d="M13.165 1.68848C13.6922 1.6839 13.8291 2.15448 13.834 2.17188V3.14062C13.834 3.14062 15.6711 3.13597 16.2666 3.14062C16.8477 3.21239 16.875 3.68555 16.875 3.68555V14.6377C16.875 14.6377 16.9167 15.1499 15.9014 15.1826C13.3766 15.188 5.82211 15.1901 1.61133 15.1826C1.19801 15.1323 1.125 14.5771 1.125 14.5771V3.74609C1.125 3.74609 1.19012 3.15236 1.7334 3.14062C2.27219 3.12906 4.13174 3.14042 4.16504 3.14062V2.17188C4.16918 2.15813 4.32181 1.66566 4.83398 1.68848C5.34353 1.71144 5.49711 2.1545 5.50293 2.17188V3.14062H8.30078V2.17188C8.30483 2.15491 8.41982 1.69531 8.96973 1.68848C9.52083 1.68178 9.63518 2.15674 9.63867 2.17188V3.14062H12.4961V2.17188C12.4985 2.15639 12.5772 1.68787 13.165 1.68848ZM2.46387 13.8516H15.5381V7.49707H2.46387V13.8516ZM2.46387 6.16602H15.5381V4.47168H2.46387V6.16602Z"
            fill="currentColor"
          />
        </svg>
        <span
          id="max-range-date-display"
          class="text-static text-label-md-medium"
        >
          {{ selectedDatepickerValue }}
        </span>
      </div>
    </div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      class="text-icon-primary transition-transform duration-200 ease-out"
      [ngClass]="{ 'rotate-180': showDatePicker }"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 9L0.75 3H11.25L6 9Z"
        fill="currentColor"
      />
    </svg>
  </button>
</div>
<span *ngIf="fieldErrorInfo?.status" class="text-caption-medium text-alert">
  {{ fieldErrorInfo?.errMessage }}
</span>
